/** Future Minds' mark: the initials in mono on a black square. Decorative —
 * the name always stands beside it in words. */
export function BrandMark({ size = "size-6" }: { size?: string }) {
  return (
    <span
      aria-hidden="true"
      className={`grid ${size} shrink-0 place-items-center rounded-control bg-ink font-mono text-2xs font-semibold text-inverse`}
    >
      FM
    </span>
  );
}
